import { getJackpotIncrement } from '@/utils/jackpotsV2/getJackpotIncrement';

const JACKPOT_TICKER_INTERVAL = 2000;
const JACKPOT_UPDATE_INTERVAL = 5 * 15 * 1000;
const JACKPOT_BASE_TICKER_VALUE_PERCENTAGE = 0.99;

const useJackpotIncrement = getJackpotIncrement(
  'JACKPOT_GAME_INTERVAL',
  JACKPOT_TICKER_INTERVAL,
  JACKPOT_UPDATE_INTERVAL,
  ({ jackpotValue, incrementValue, previousJackpotValue }) => {
    if (incrementValue) {
      return jackpotValue;
    }
    if (jackpotValue < previousJackpotValue) {
      return jackpotValue * JACKPOT_BASE_TICKER_VALUE_PERCENTAGE;
    }
    return Math.max(
      jackpotValue * JACKPOT_BASE_TICKER_VALUE_PERCENTAGE,
      previousJackpotValue
    );
  }
);

export default useJackpotIncrement;
